import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Award } from 'lucide-react';

export default function TrademarkPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Award className="h-6 w-6 text-blue-600" />
              Trademark & Legal Notice
            </CardTitle>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none">
            <h2 className="text-lg font-semibold mt-4">Trademarks</h2>
            <p>
              <strong>AbbeyZone</strong> and <strong>Abbey 5 Star</strong> are trademarks of Abbey 5 Star Ltd.
              All rights reserved.
            </p>

            <h2 className="text-lg font-semibold mt-6">Copyright</h2>
            <p>
              © {new Date().getFullYear()} Abbey 5 Star Ltd. All content, design, and functionality of the 
              AbbeyZone platform are protected by copyright and other intellectual property laws.
            </p>

            <h2 className="text-lg font-semibold mt-6">Third-Party Trademarks</h2>
            <p>
              Other product names, logos, and brands mentioned on this platform are property of their 
              respective owners. Any use of third-party trademarks is for identification purposes only 
              and does not imply endorsement.
            </p>

            <h2 className="text-lg font-semibold mt-6">Disclaimer</h2>
            <p>
              The information provided through AbbeyZone is for general informational purposes. While we 
              strive to keep information accurate and up-to-date, we make no warranties about the completeness, 
              reliability, or accuracy of this information.
            </p>

            <h2 className="text-lg font-semibold mt-6">Limitation of Liability</h2>
            <p>
              Abbey 5 Star Ltd shall not be liable for any direct, indirect, incidental, consequential, 
              or punitive damages arising from the use of or inability to use our services.
            </p>

            <h2 className="text-lg font-semibold mt-6">Governing Law</h2>
            <p>
              These terms are governed by and construed in accordance with the laws of England and Wales. 
              Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>

            <div className="mt-8 p-4 bg-slate-100 rounded-lg">
              <p className="text-sm text-muted-foreground">
                <strong>Abbey 5 Star Ltd</strong><br />
                Registered in England and Wales<br />
                <a href="https://www.abbey5star.co.uk" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                  www.abbey5star.co.uk
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
